import userConstants from 'core/constants/userConstants'

const FilterStorage = {
    setFilterData: (filterData, filterName) => {
        localStorage.setItem(filterName, JSON.stringify(filterData))
    },
    getFilterData: (filterName) => {
        return JSON.parse(localStorage.getItem(filterName)) || null
    },
    clearFilterData: (filterName) => {
        localStorage.removeItem(filterName)
    },
    clearAllFilterData: () => {
        localStorage.removeItem(userConstants.FILTER_ADMIN)
        localStorage.removeItem(userConstants.FILTER_CAJA)
        localStorage.removeItem(userConstants.FILTER_CECO)
        localStorage.removeItem(userConstants.FILTER_CONTABILIDAD)
        
        localStorage.removeItem(userConstants.FILTER_RENDICION)
        localStorage.removeItem(userConstants.FILTER_APERTURA_CAJA)
        localStorage.removeItem(userConstants.FILTER_ADELANTO_OPERATION)
        localStorage.removeItem(userConstants.FILTER_DEVOLUCION_OPERATION)
        localStorage.removeItem(userConstants.FILTER_ADELANTO_CASH)
        localStorage.removeItem(userConstants.FILTER_DEVOLUCION_CASH)
        localStorage.removeItem(userConstants.FILTER_ARQUEO_CAJA)
        localStorage.removeItem(userConstants.FILTER_PAGO_CAJA)
    }
}

export default FilterStorage;
